// ===========================================================================
// SLIDER IMMAGINI THUMB DA TABLET / DESKTOP
// ===========================================================================
$(window).on('load', function () {

  // se mi trovo nel dettaglio articolo
  if ($('#dettaglio-articolo').length) {

    // valore inziziale traslato
    let traslato = 0;

    // recupero l'altezza di ogni singola thumb, aggiungo
    // padding, bordi e margini e moltiplico per il numero di thumb
    // da visualizzare. Aggiungo 5 per padding finale.
    let altezza = $('.thumb-details').height();
    altezza += 16;
    altezza *= 5;
    altezza += 5;

    // Setto l'altezza della colonna delle thumb
    $('#gallery-column .row').css('max-height', '' + altezza + 'px');

    // Se ci sono più di 5 thumb mostro il pulsante per lo scorrimento
    if ($('.thumb-details').length > 5) {
      $('#scroll-gallery-bottom').show();
    }

    // calcolo il numero di scorrimenti
    let volte = 1;
    const conta = Math.ceil($('.thumb-details').length / 5);

    // Al click sullo scroll
    $('#scroll-gallery-bottom').click(function () {

      traslato += altezza;
      $('#translate-content').css('transform', 'translateY(-' + traslato + 'px)');
      volte += 1;

      if (volte === conta) {
        // nascondo la freccia in giù e mostro la freccia in su
        $('#scroll-gallery-bottom').hide();
        $('#scroll-gallery-top').show();
      } else if (volte !== 1) {
        // mostro la freccia in su
        $('#scroll-gallery-top').show();
      }
    });


    $('#scroll-gallery-top').click(function () {

      traslato -= altezza;
      $('#translate-content').css('transform', 'translateY(-' + traslato + 'px)');
      volte -= 1;
      console.log(volte);

      if (volte === 1) {

        // nascondo la freccia in su
        $('#scroll-gallery-top').hide();
        $('#scroll-gallery-bottom').show();

      } else if (volte !== conta) {

        $('#scroll-gallery-bottom').show();
      }

    });

  }
});
